import regisMeetingRoom from "../views/adminstration/phonghop/hc-phonghop-index.vue";
import regisMeetingRoomDx from "../views/adminstration/phonghop/PhongHopDx_Index";
import regisMeetingRoomDetail from "../views/adminstration/phonghop/hc-phonghop-detail.vue";
import regisMeetingRoomDetailDx from "../views/adminstration/phonghop/PhongHopDx_Detail.vue";
import getCar from "../views/adminstration/dieuxe/dieuXe_Index.vue";
import getCarDx from "../views/adminstration/dieuxe/dieuXeDotXuat_Index.vue";
import getCarDetail from "../views/adminstration/dieuxe/hc-dieuxe-detail.vue";
import getCarDetailDx from "../views/adminstration/dieuxe/dieuXeDotXuat_Detail.vue";
import regisMeetingRoomCalendar from "../views/adminstration/phonghop/PhongHop_Calendar.vue";
import getCarCalendar from "../views/adminstration/dieuxe/dieuXe_Calendar.vue";
import regiscalendarweek from "../views/adminstration/lichtuan/LichTuan_Index.vue";
import regiscalendarweekCalendar from "../views/adminstration/lichtuan/LichTuan_Calendar.vue";
import regiscalendarweekDetail from "../views/adminstration/lichtuan/LichTuan_Detail.vue";
import administrationTools from "../views/adminstration/tools/Tool_Index";
import administrationToolsDetail from "../views/adminstration/tools/Tool_Detail";
import hcCaseCalendarAttachment from "../views/adminstration/lichtuan/hcCaseCalendarAttachment";
import rankingReasonIndex from "../views/adminstration/reason/ranking-reason-index";

export default [
  /*Route đăng ký phòng họp */
  /*Route index */
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom",
    name: "adminstration-index",
    component: regisMeetingRoom
  },
  /*Route xem chi tiết từng yêu cầu đăng ký phòng họp*/
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom/detail/:id",
    name: "adminstration-detail",
    components: {
      default: regisMeetingRoom,
      detail: regisMeetingRoomDetail
    }
  },
  /*Route xem lịch đăng ký phòng họp  */
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom/calendar",
    name: "adminstration-regisRoomCalendar",
    components: {
      default: regisMeetingRoom,
      detail: regisMeetingRoomCalendar
    }
  },
  /*Route đăng ký phòng họp đột xuất*/
  /*Route index */
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom-dx",
    name: "adminstration-dx",
    component: regisMeetingRoomDx
  },
  /*Route xem chi tiết từng yêu cầu đăng ký phòng họp đột xuất*/
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom-dx/detail/:id",
    name: "adminstration-detail-dx",
    components: {
      default: regisMeetingRoomDx,
      detail: regisMeetingRoomDetailDx
    }
  },
  /*Route xem lịch đăng ký phòng họp  */
  {
    path: "/app/:userDeptRoleId/administrasion/regisroom-dx/calendar",
    name: "adminstration-dx-regisRoomCalendar",
    components: {
      default: regisMeetingRoomDx,
      detail: regisMeetingRoomCalendar
    }
  },
  /*Route điều xe */
  /*Route index*/
  {
    path: "/app/:userDeptRoleId/administrasion/getcar",
    name: "adminstration-getCar",
    component: getCar
  },
  /*Route xem chi tiết từng yêu cầu điều xe */
  {
    path: "/app/:userDeptRoleId/administrasion/getcar/detail/:id",
    name: "adminstration-getCarDetail",
    components: {
      default: getCar,
      detail: getCarDetail
    }
  },
  /*Route xem lịch điều xe */
  {
    path: "/app/:userDeptRoleId/administrasion/getcar/calendar",
    name: "adminstration-getCarCalendar",
    components: {
      default: getCar,
      detail: getCarCalendar
    }
  },
  /*Route điều xe khẩn cấp */
  /*Route index*/
  {
    path: "/app/:userDeptRoleId/administrasion/getcar-dx",
    name: "adminstration-getCar-dx",
    component: getCarDx
  },
  /*Route xem chi tiết từng yêu cầu điều xe khẩn cấp*/
  {
    path: "/app/:userDeptRoleId/administrasion/getcar-dx/detail/:id",
    name: "adminstration-getCarDetail-dx",
    components: {
      default: getCarDx,
      detail: getCarDetailDx
    }
  },
  /*Route xem lịch điều xe */
  {
    path: "/app/:userDeptRoleId/administrasion/getcar-dx/calendar",
    name: "adminstration-dx-getCarCalendar",
    components: {
      default: getCar,
      detail: getCarCalendar
    }
  },
  /* Router lịch tuần */
  /* Route index */
  {
    path: "/app/:userDeptRoleId/administrasion/hcCaseCalendarAttachment",
    name: "hcCaseCalendarAttachment",
    component: hcCaseCalendarAttachment
  },
  {
    path: "/app/:userDeptRoleId/administrasion/regiscalendarweek",
    name: "adminstration-regiscalendarweek",
    component: regiscalendarweek
  },
  {
    path: "/app/:userDeptRoleId/administrasion/regiscalendarweek/calendar",
    name: "adminstration-regiscalendarweekCalendar",
    components: {
      default: regiscalendarweek,
      detail: regiscalendarweekCalendar
    }
  },

  //chi tiết lịch tuần
  {
    path: "/app/:userDeptRoleId/administrasion/regiscalendarweek/detail/:id",
    name: "adminstration-regiscalendarweek-detail",
    components: {
      default: regiscalendarweek,
      detail: regiscalendarweekDetail
    }
  },

  // Tool index
  {
    path: "/app/:userDeptRoleId/toolchc",
    name: "administration-tools",
    component: administrationTools
  },
  // Tool detail
  {
    path: "/app/:userDeptRoleId/toolchc/detail/:deptId/:flowCode",
    name: "administration-tools-detail",
    components: {
      default: administrationTools,
      detail: administrationToolsDetail
    }
  },

  {
    path: "/app/:userDeptRoleId/administrasion/rankingReasonIndex",
    name: "rankingReasonIndex",
    component: rankingReasonIndex
  }
];



// WEBPACK FOOTER //
// ./src/router/adminstration.js